module.exports = require("apollo-link-queue");